export const AnnouncementStatus = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
} as const;

export type AnnouncementStatusType =
  (typeof AnnouncementStatus)[keyof typeof AnnouncementStatus];

export interface AnnouncementAuthor {
  userId: string;
  name: string;
  email: string;
}

export interface AnnouncementDetails {
  id: string;
  title: string;
  bodyHtml: string;
  status: AnnouncementStatusType;
  isPinned: boolean;
  publishedAt: string | null;
  expiresAt: string | null;
  createdBy: AnnouncementAuthor;
  updatedBy: AnnouncementAuthor;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateAnnouncementPayload {
  title: string;
  bodyHtml: string;
  status?: AnnouncementStatusType;
  isPinned?: boolean;
  expiresAt?: string | null;
}

export type UpdateAnnouncementPayload = Partial<CreateAnnouncementPayload>;

export interface GetAnnouncementsParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface AnnouncementsPagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface AnnouncementsResponse {
  data: Array<AnnouncementDetails>;
  pagination: AnnouncementsPagination;
}
